import axios from "axios";

export const getUserAnalyticsList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DATABASEURL}/api/v2/analytics/admin/active`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`, // Uncomment if using auth
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error at getting all referrals: ${error}`);
  }
};

export const getSelectedUserAnalyticsDeatils = async userId => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DATABASEURL}/api/v2/analytics/admin/${userId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error at get coupons used users: ${error}`);
  }
};
